// The levels of a pitchfork are objects: a copy must not share them
const copyStyle = ({ levels, ...style }) => (levels ? { ...style, levels: levels.map((level) => ({ ...level })) } : style);

/**
 * A drawing of the user.
 *
 * @param {string} id
 * @param {string} type - DRAWING_TOOL value
 * @param {Array<{ time: number, price: number }>} points - time in ms
 * @param {{ color: string, width: number }} style - CSS colour, CSS px; what a tool has beyond them: drawingStyles.js
 * @returns {{ id: string, type: string, points: object[], style: object, isLocked: boolean, isVisible: boolean }}
 */
export const createDrawingItem = (id, type, points, style) => ({
  id,
  type,
  points,
  style: copyStyle(style),
  isLocked: false,
  isVisible: true,
});

/**
 * @param {object} item - from createDrawingItem
 * @returns {object} a copy for the outside world: changing it does not touch the drawing
 */
export const copyDrawingItem = ({ points, style, ...rest }) => ({
  ...rest,
  points: points.map((point) => ({ ...point })),
  style: copyStyle(style),
});
